import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Page from "../../../components/Page";
import Article from "../../../components/Article";
import CustomButton from '../../../components/CustomButton';
import { useNavigate, useParams } from 'react-router-dom';
import { Routes } from '../../../routes/RouteConstants';

const EmailActionSuccessPage = () => {
  const navigate = useNavigate();
  const { type } = useParams();

  let title;
  if (type === 'booking-approval') {
    title = 'Sikeresen jóváhagytad a foglalást';
  } else if (type === 'booking-rejection') {
    title = 'Sikeresen elutasítottad a foglalást';
  }

  return (
    <Page>
      <Article title={title} titleVariant="h5">
        <CheckCircleIcon sx={{ fontSize: 60, color: 'green', mb: 3 }} />
        <CustomButton variant="outlined" text="Foglalások megtekintése" onClick={() => navigate(Routes.DASHBOARD)} mt={1} />
      </Article>
    </Page>
  );
};

export default EmailActionSuccessPage;
